import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    userReqId: "",
    userReqAddress: "",
    userHnNumber: "",
  },
  reducers: {
    setUserReqId: (state, action) => {
      state.userReqId = action.payload;
    },
    setUserReqAddress: (state, action) => {
      state.userReqAddress = action.payload;
    },
    setUserHnNumber: (state, action) => {
      state.userHnNumber = action.payload;
    },
  },
});

export const { setUserReqId, setUserReqAddress, setUserHnNumber } = userSlice.actions;

export default userSlice.reducer;
